import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class SecurityService {
  uploadImage: any;
  credenciales = {
    grant_type: "client_credentials",
    client_id: 2,
    client_secret: "863EOgvVNFYgvVzwEWyvsi6qqX11GNtJN3Mf7kwt"
  };
  readonly urlBase = environment.rutaBase;
  //readonly urlBase =  "http://localhost:9090";
  TOKEN: string;
  
  idEmpresa_Factor:any;
  constructor(private http: HttpClient, private accesoService: AccesoService) { 
    
    this.idEmpresa_Factor= environment.ID_EMPRESA; 
  }

  obtenerToken() {
    return this.http.post(
      `${this.urlBase}/security/token`, this.credenciales);
  }

  createUsuario(usuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/usersPR`, usuario, { headers });
  }

  validarUsuario(datos: any) {
    /*let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `LeSTmBpWtEsh5Nb6V6bXxxxER`);
    return this.http.post(`http://localhost:8800/api-seguridad/ValidateToken/${idUser}`,datos,{ headers } )*/

    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/loginPR`, datos, { headers });
  }

  validaToken(idUser: any,datos: any) {
    /*let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `RYNOkfTEyhm2LZOhohvRHCBwfSx8l9`);
    return this.http.post(`http://localhost:8800/api-seguridad/ValidateToken/${idUser}`,datos,{ headers } )*/

    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/ValidateToken/${idUser}`, datos, { headers });
  }

  listarUsuarios(usuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(`${this.urlBase}/security/users?usuario=${usuario}`, { headers });
  }

  ObtenerUsuarios(TipoUsuario : any){
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(`${this.urlBase}/security/usersPR?TipoUsuario=${TipoUsuario}`, { headers } );
    // return  this.http.get(`${this.urlBase}/security/usersPR`,{headers});
  }

  recuperarCuenta(usuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/recover`, usuario, { headers });
  }

  cambiarContraseña(usuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/changePasswordPR`, usuario, { headers });
  }

  Dashboard1(tipo: any, proveedor: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(`${this.urlBase}/reporte/Extranet/${tipo}/${proveedor}?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  ActualizarUsuario(idUsuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(`${this.urlBase}/security/updatePR`, { headers });
  }

  DesactivarUsuario(usuario: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.post(`${this.urlBase}/security/DesactivarUsuario`, usuario, { headers });
  }

  // DesactivarUsuario(data:any){
  //   let headers :  HttpHeaders = new HttpHeaders();
  //   headers =  headers.append('Accept', 'application/json');
  //   headers =  headers.append('Authorization', `hIlU8KlOT1`);
  //   return this.http.post(`http://localhost:2528/api-seguridad/DesactivarUsuario`,data,{ headers } )
  // }

  SubirFotoUser(foto: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .post(`${this.urlBase}/security/ImagenPR`, foto, { headers })
      .pipe(
        map((data) => {
          return data;
        }));
  }
  ListarPreguntas(id_user:any){
      let headers = this.accesoService.desencriptarTOKEN();
      return this.http
        .get(`${this.urlBase}/configuraciones/preguntas_frecuentes?id_User=${id_user}`,{headers});
  }
  ListarCodigo(id_user:any){
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(`${this.urlBase}/configuraciones/codigo_promocion?id_User=${id_user}`,{headers});
}
}
